import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './app/redux/store';
import {MetronicI18nProvider} from './_metronicPatient/i18n/Metronici18n'
import './_metronicPatient/assets/fonticon/fonticon.css'
import './_metronicPatient/assets/keenicons/duotone/style.css'
import './_metronicPatient/assets/keenicons/outline/style.css'
import './_metronicPatient/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronicPatient/assets/sass/style.scss'
import './_metronicPatient/assets/sass/plugins.scss'
import './_metronicPatient/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
// import {AuthProvider, setupAxios} from './app/patientModule/auth_'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
// setupAxios(axios)
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
    <QueryClientProvider client={queryClient}>
      <MetronicI18nProvider>
        {/* <AuthProvider> */}
          <AppRoutes />
        {/* </AuthProvider> */}
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
    </PersistGate>
    </Provider>
  )
}
